export function selectCanvasAsset(dispatch, canvasData) {
  dispatch({type: 'ASSET_SELECTED', payload: canvasData});
}
